import { render, staticRenderFns } from "./EditDocument.vue?vue&type=template&id=1463358f&scoped=true"
import script from "./EditDocument.vue?vue&type=script&lang=js"
export * from "./EditDocument.vue?vue&type=script&lang=js"
import style0 from "./EditDocument.vue?vue&type=style&index=0&id=1463358f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1463358f",
  null
  
)

export default component.exports